<template>
  <svg width="12" height="12" viewBox="0 0 12 12"  xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0)">
      <path
          d="M1.74716 11.2827H0.896896L1.49812 10.6815C1.8223 10.3573 2.02473 9.93566 2.07916 9.47827C0.690915 8.56723 0 7.24744 0 5.86382C0 3.31121 2.34609 0.717163 6.02033 0.717163C9.91279 0.717163 12 3.10417 12 5.64018C12 8.19291 9.89074 10.5783 6.02033 10.5783C5.34233 10.5783 4.63484 10.4878 4.00319 10.3217C3.40525 10.935 2.59508 11.2827 1.74716 11.2827Z"
          fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="12" height="12" fill="white"/>
      </clipPath>
    </defs>
  </svg>

</template>

<script>
export default {
  name: "IconComment"
}
</script>

<style scoped>

</style>